import History from '@shared/svg/history.svg'
import Rub from '@shared/svg/rub.svg'
import Safety from '@shared/svg/safety.svg'

export const partnerFormSummary = [
	{
		Icon: Rub,
		content: 'Проверяйте клиента по понятному чек-листу',
	},
	{
		Icon: Safety,
		content: 'Передавайте заявки и контролируйте процесс',
	},
	{
		Icon: History,
		content: 'Получайте комиссию и вознаграждение за сделки',
	},
]
